import { number } from 'prop-types';
import { getStringByLang } from './lang';
import { tag_popular_list_ko } from '../lang/tag_popular_list.ko';
import { tag_popular_list_jp } from '../lang/tag_popular_list.jp';
import { tag_popular_list_en } from '../lang/tag_popular_list.en';
import {
  tag_list_animals_birds_ko,
  tag_list_art_periods_ko,
  tag_list_colours_ko,
  tag_list_flowers_leaves_ko,
  tag_list_food_drink_ko,
  tag_list_objects_ko,
  tag_list_pattern_techniques_ko,
  tag_list_pattern_types_ko,
  tag_list_seasons_ko,
} from '../lang/tag_sub_sub_list.ko';
import {
  tag_list_animals_birds_en,
  tag_list_art_periods_en,
  tag_list_colours_en,
  tag_list_flowers_leaves_en,
  tag_list_food_drink_en,
  tag_list_objects_en,
  tag_list_pattern_techniques_en,
  tag_list_pattern_types_en,
  tag_list_seasons_en,
} from '../lang/tag_sub_sub_list.en';
import {
  tag_list_animals_birds_jp,
  tag_list_art_periods_jp,
  tag_list_colours_jp,
  tag_list_flowers_leaves_jp,
  tag_list_food_drink_jp,
  tag_list_objects_jp,
  tag_list_pattern_techniques_jp,
  tag_list_pattern_types_jp,
  tag_list_seasons_jp,
} from '../lang/tag_sub_sub_list.jp';
import { tag_list_ko } from '../lang/tag_list.ko';
import { tag_list_jp } from '../lang/tag_list.jp';
import { tag_list_en } from '../lang/tag_list.en';

export const CONFIG_MESSAGE = {
  INVALID_ENTER_EMAIL_MSG: getStringByLang(
    '이메일 형식이 올바르지 않습니다.',
    'Email format is invalid.',
    'メールの形式が正しくありません。',
  ),
  REQUEST_ONLY_ENTER_ENGLISH_MSG: getStringByLang(
    '영어로만 입력 가능합니다.',
    'You can only enter in English.',
    '英語でのみ入力可能です。',
  ),
  REQUEST_ENTER_REFUND_REASON_MSG: getStringByLang(
    '환불 사유를 입력해주세요.',
    'Please enter a reason for the refund.',
    '返金理由を入力してください。',
  ),
  REQUEST_SELECT_REFUND_TYPE_MSG: getStringByLang(
    '환불 유형을 선택해주세요.',
    'Please select a refund type.',
    '返金タイプを選択してください。',
  ),
  REQUEST_SELECT_REFUND_ITEM_MSG: getStringByLang(
    '환불 상품을 선택해주세요.',
    'Please select a refund item.',
    '返金商品を選択してください。',
  ),
  CONFIRM_PURCHASE_ITEM_EXIST_MSG: getStringByLang(
    '구매확정인 아이템이 있습니다. 다시 확인해주세요.',
    'There are items that have been confirmed for purchase. Please check again.',
    '購入確定のアイテムがあります。もう一度確認してください。',
  ),
  CONFIRM_DELETE_MSG: getStringByLang(
    '정말 삭제하시겠습니까?',
    'Are you sure you want to delete?',
    '本当に削除しますか？',
  ),
  REQUEST_ENTER_REPORT_REASON_MSG: getStringByLang(
    '신고 사유를 입력해주세요.',
    'Please enter a reason for the report.',
    '通報理由を入力してください。',
  ),
  REQUEST_ENTER_REVIEW_MSG: getStringByLang(
    '상품평을 입력해주세요',
    'Please enter a review.',
    '商品レビューを入力してください。',
  ),
  MIN_RATING_MSG: (number) =>
    getStringByLang(
      `별점은 ${number}점 이상이어야 합니다.`,
      `Rating must be at least ${number} stars.`,
      `評価は${number}点以上である必要があります。`,
    ),
  REQUEST_PAYPAL_EMAIL_MSG: getStringByLang(
    '페이팔 이메일을 입력해주세요.',
    'Please enter your PayPal email.',
    'PayPalのメールアドレスを入力してください。',
  ),
  REQUEST_CHECK_COUNTRY_EUR_BEFORE_WITHDRAWAL_MSG: getStringByLang(
    '언어를 영어-EUR로 설정 후 금액을 확인해주세요.',
    'Please set the language to English-EUR and check the amount.',
    '言語を英語-EURに設定して金額を確認してください。',
  ),
  REQUEST_CHECK_COUNTRY_USD_BEFORE_WITHDRAWAL_MSG: getStringByLang(
    '언어를 영어-USD로 설정 후 금액을 확인해주세요.',
    'Please set the language to English-USD and check the amount.',
    '言語を英語-USDに設定して金額を確認してください。',
  ),
  REQUEST_CHECK_COUNTRY_KR_BEFORE_WITHDRAWAL_MSG: getStringByLang(
    '언어를 한국어로 설정 후 금액을 확인해주세요.',
    'Please set the language to Korean and check the amount.',
    '言語を韓国語に設定して金額を確認してください。',
  ),
  REQUEST_CURRENCY_SET_BEFORE_WITHDRAWAL_MSG: getStringByLang(
    '출금 신청 전 마이페이지에서 통화 설정이 필요합니다.',
    'You need to set the currency in My Page before applying for withdrawal.',
    '出金申請前にマイページで通貨設定が必要です。',
  ),
  REQUEST_UPLOAD_IMAGE_MSG: getStringByLang(
    '이미지 파일을 업로드해주세요.',
    'Please upload an image file.',
    '画像ファイルをアップロードしてください。',
  ),
  FAIL_GET_RESULT_MSG: getStringByLang(
    '결과를 가져오는데 실패했습니다. 다시 시도해주세요.',
    'Failed to get results. Please try again.',
    '結果を取得できませんでした。もう一度お試しください。',
  ),
  MAX_FILE_WIDTH_HEIGHT_MSG: (width, height) =>
    getStringByLang(
      `이미지의 최대 크기는 ${width}x${height}px 입니다.`,
      `The maximum size of the image is ${width}x${height}px.`,
      `画像の最大サイズは${width}x${height}pxです。`,
    ),
  REQUEST_SELECTED_MOTIF_STYLE_MSG: getStringByLang(
    '모티프 스타일을 선택해주세요.',
    'Please select a motif style.',
    'モチーフスタイルを選択してください。',
  ),
  SUCCESS_EDIT_PRODUCT_MSG: getStringByLang(
    '상품이 수정되었습니다.',
    'Product has been edited.',
    '商品が修正されました。',
  ),
  REQUEST_SELECT_COLOR_MSG: getStringByLang('컬러를 선택해주세요.', 'Please select a color.', '色を選択してください。'),
  SUCCESS_ADD_PRODUCT_MSG: getStringByLang(
    '상품이 등록되었습니다.',
    'Product has been added.',
    '商品が登録されました。',
  ),
  REQUEST_ENTER_PRODUCT_NAME_MSG: getStringByLang(
    '상품명을 입력해주세요.',
    'Please enter a product name.',
    '商品名を入力してください。',
  ),
  MAX_SELECTION_MSG: (number) =>
    getStringByLang(
      `최대 ${number}개 까지 선택 가능합니다.`,
      `You can select up to ${number} items.`,
      `最大${number}個まで選択可能です。`,
    ),
  FAIL_STYLE_EDIT_NOT_ALLOWED_MSG: getStringByLang(
    '스타일 수정이 불가능한 상품입니다.',
    'This product cannot be edited for style.',
    'この商品はスタイルの編集ができません。',
  ),
  MIN_ENTER_CHAR_MSG: (number) =>
    getStringByLang(
      `최소 ${number}자 이상 입력해주세요.`,
      `Please enter at least ${number} characters.`,
      `最低${number}文字以上入力してください。`,
    ),
  REQUEST_ONLY_JPG_FILE_MSG: getStringByLang(
    'JPG 파일 또는 JPEG 만 업로드 가능합니다.',
    'Only JPG or JPEG files can be uploaded.',
    'JPGファイルまたはJPEGのみアップロード可能です。',
  ),
  REQUEST_ONLY_PSD_FILES_MSG: getStringByLang(
    'PSD 파일만 업로드 가능합니다.',
    'Only PSD files can be uploaded.',
    'PSDファイルのみアップロード可能です。',
  ),
  REQUEST_ONLY_AI_FILES_MSG: getStringByLang(
    'AI 파일만 업로드 가능합니다.',
    'Only AI files can be uploaded.',
    'AIファイルのみアップロード可能です。',
  ),
  REQUEST_ENTER_PRODUCT_DESCRIPTION_MSG: getStringByLang(
    '상품 설명을 입력해주세요.',
    'Please enter a product description.',
    '商品説明を入力してください。',
  ),
  REQUEST_SELECT_CATEGORY_MSG: getStringByLang(
    '카테고리를 선택해주세요.',
    'Please select a category.',
    'カテゴリーを選択してください。',
  ),
  REQUEST_SELECT_STYLE_MSG: getStringByLang(
    '스타일을 선택해주세요.',
    'Please select a style.',
    'スタイルを選択してください。',
  ),
  REQUEST_REGISTER_THUMBNAIL_MSG: getStringByLang(
    '썸네일 이미지를 등록해주세요.',
    'Please upload a thumbnail image.',
    'サムネイル画像を登録してください。',
  ),
  REQUEST_REGISTER_TAGS_MSG: getStringByLang(
    '태그를 등록해주세요.',
    'Please register tags.',
    'タグを登録してください。',
  ),
  REQUEST_PSD_OR_VECTOR_REQUIRED_MSG: getStringByLang(
    'PSD 또는 벡터 파일 중 하나는 필수입니다.',
    'Either a PSD or vector file is required.',
    'PSDまたはベクターファイルのいずれかが必要です。',
  ),
  MIN_PSD_RESOLUTION_MSG: (number) =>
    getStringByLang(
      `PSD 파일은 최소 ${number}dpi 이상이어야 합니다.`,
      `PSD files must be at least ${number}dpi.`,
      `PSDファイルは最低${number}dpiである必要があります。`,
    ),
  REQUEST_SELECT_PATTERN_TYPE_MSG: getStringByLang(
    '패턴 유형을 선택해주세요.',
    'Please select a pattern type.',
    'パターンタイプを選択してください。',
  ),
  REQUEST_SELECT_MAPPING_IMG_MSG: (number) =>
    getStringByLang(
      `매핑 이미지를 ${number}장 선택해주세요.`,
      `Please select ${number} mapping images.`,
      `${number}枚のマッピング画像を選択してください。`,
    ),
  REQUEST_SELECT_LICENSE_MSG: getStringByLang(
    '라이선스를 선택해주세요.',
    'Please select a license.',
    'ライセンスを選択してください。',
  ),
  REQUEST_ENTER_VIP_PRICE_MSG: getStringByLang(
    '개인용/상업용 가격을 모두 입력해주세요.',
    'Please enter both personal and commercial prices.',
    '個人用/商業用の価格を両方入力してください。',
  ),
  REQUEST_ENTER_PREMIUM_PRICE_MSG: getStringByLang(
    '독점판매용 가격을 입력해주세요.',
    'Please enter a price for exclusive sale.',
    '独占販売用の価格を入力してください。',
  ),
  SUCCESS_DELETE_PRODUCT_MSG: getStringByLang(
    '상품이 삭제되었습니다.',
    'Product has been deleted.',
    '商品が削除されました。',
  ),
  SELECT_ITEMS_TO_DELETE_MSG: getStringByLang(
    '삭제할 항목을 선택해주세요',
    'Please select items to delete',
    '削除する項目を選択してください',
  ),
  EDIT_VIP_PRODUCT_REQUIRES_VIP_SELLER_MSG: getStringByLang(
    'VIP 상품 수정을 위해서는 VIP Seller 멤버십이 필요합니다.',
    'VIP Seller membership is required to edit VIP products.',
    'VIP商品を修正するには、VIP Sellerメンバーシップが必要です。',
  ),
  REJECTED_PRODUCT_MSG: getStringByLang(
    '승인 거부된 상품입니다. 관리자에게 문의해주세요.',
    'This product has been rejected. Please contact the administrator.',
    '承認拒否された商品です。管理者にお問い合わせください。',
  ),
  PENDING_APPROVAL_PRODUCT_MSG: getStringByLang(
    '승인 대기 중입니다. 관리자 승인 후 이용 가능합니다.',
    'Pending approval. You can use it after admin approval.',
    '承認待ちです。管理者の承認後に利用可能です。',
  ),
  SUCCESS_REMOVE_FAVORITE_PRODUCT_MSG: getStringByLang(
    '상품이 관심상품에서 삭제되었습니다.',
    'Product has been removed from favorite products.',
    '商品が関心商品から削除されました。',
  ),
  SUCCESS_ADD_FAVORITE_PRODUCT_MSG: getStringByLang(
    '상품이 관심상품으로 등록되었습니다.',
    'Product has been added to favorite products.',
    '商品が関心商品に登録されました。',
  ),
  REQUEST_LOGIN_MSG: getStringByLang(
    '로그인 후 이용 가능합니다.',
    'You need to log in to use this service.',
    'ログイン後に利用可能です。',
  ),
  SUCCESS_DELETE_FAVORITE_GROUP_MSG: getStringByLang(
    '그룹이 삭제되었습니다.',
    'Group has been deleted.',
    'グループが削除されました。',
  ),
  MAX_GROUP_TITLE_MSG: (number) =>
    getStringByLang(
      `그룹명은 최대 ${number}자 까지 입력 가능합니다.`,
      `Group name can be up to ${number} characters long.`,
      `グループ名は最大${number}文字まで入力可能です。`,
    ),
  REQUEST_GROUP_TITLE_MSG: getStringByLang(
    '그룹명을 입력해주세요.',
    'Please enter a group name.',
    'グループ名を入力してください。',
  ),
  DOUBLE_GROUP_TITLE_MSG: getStringByLang(
    '중복된 그룹명입니다.',
    'The group name is duplicated.',
    '同じグループがあります。',
  ),
  SUCCESS_ADD_GROUP_MSG: getStringByLang(
    '그룹이 추가되었습니다.',
    'Group has been added.',
    'グループが追加されました。',
  ),
  SUCCESS_EDIT_GROUP_TITLE_MSG: getStringByLang(
    '그룹명 수정이 완료되었습니다.',
    'Group name modification is complete.',
    'グループ名の修正が完了しました。',
  ),
  MIN_GROUP_NUMBER_MSG: (number) =>
    getStringByLang(
      `그룹은 최소 ${number}개 이상이어야 합니다.`,
      `At least ${number} groups are required.`,
      `グループは最低${number}個以上である必要があります。`,
    ),
  MIN_GROUP_TITLE_MSG: (number) =>
    getStringByLang(
      `그룹명은 최소 ${number}자 이상이어야 합니다.`,
      `Group name must be at least ${number} characters long.`,
      `グループ名は最低${number}文字以上である必要があります。`,
    ),
  SUCCESS_EDIT_SELLER_MSG: getStringByLang(
    '판매자 계정 수정이 완료되었습니다.',
    'Seller account modification is complete.',
    '販売者アカウントの修正が完了しました。',
  ),
  SUCCESS_REGISTER_SELLER_MSG: getStringByLang(
    '판매자 등록이 완료되었습니다.',
    'Seller registration is complete.',
    '販売者登録が完了しました。',
  ),
  FAIL_PORTFOLIO_UPLOAD_MSG: getStringByLang(
    '포트폴리오 파일 업로드에 실패했습니다. 다시 시도해주세요.',
    'Failed to upload portfolio file. Please try again.',
    'ポートフォリオファイルのアップロードに失敗しました。もう一度お試しください。',
  ),
  PORTFOLIO_MAX_FILE_MSG: (number) =>
    getStringByLang(
      `포트폴리오 파일은 최대 ${number}개 까지 첨부 가능합니다.`,
      `You can attach up to ${number} portfolio files.`,
      `ポートフォリオファイルは最大${number}個まで添付可能です。`,
    ),
  REQUEST_AGREE_LICENSE_MSG: getStringByLang(
    '판매자 라이선스 약관에 동의해주세요.',
    'Please agree to the seller license terms.',
    '販売者ライセンス規約に同意してください。',
  ),
  REQUEST_PORTFOLIO_MIN_FILE_MSG: (number) =>
    getStringByLang(
      `${number} 이상의 포트폴리오 파일을 첨부해주세요.`,
      `Please attach ${number} or more portfolio files.`,
      `${number}以上のポートフォリオファイルを添付してください。`,
    ),
  REQUEST_EDUCATION_HISTORY_MSG: getStringByLang(
    '학력을 입력해주세요.',
    'Please enter your educational background.',
    '学歴を入力してください。',
  ),
  REQUEST_INTRODUCE_MSG: getStringByLang(
    '자기소개를 입력해주세요.',
    'Please enter a self-introduction.',
    '自己紹介を入力してください。',
  ),
  REQUEST_BANK_ACCOUNT_MSG: getStringByLang(
    '계좌번호를 입력해주세요.',
    'Please enter the bank account number.',
    '口座番号を入力してください。',
  ),
  REQUEST_ACCOUNT_NAME_MSG: getStringByLang(
    '예금주명을 입력해주세요.',
    'Please enter the account holder name.',
    '口座名義を入力してください。',
  ),
  REQUEST_SELECTED_BANK_MSG: getStringByLang(
    '은행을 선택해주세요.',
    'Please select a bank.',
    '銀行を選択してください。',
  ),
  REQUEST_PAYMENT_EMAIL_ADDRESS_MSG: getStringByLang(
    '결제 영수증 발행용 이메일을 입력해주세요.',
    'Please enter your email for payment receipt issuance.',
    '支払い領収書発行用のメールアドレスを入力してください。',
  ),
  REQUEST_TAX_BILL_EMAIL_MSG: getStringByLang(
    '세금계산서 발행용 이메일을 입력해주세요.',
    'Please enter your email for tax invoice issuance.',
    '税金計算書発行用のメールアドレスを入力してください。',
  ),
  REQUEST_BUSINESS_FILE_NUMBER_MSG: getStringByLang(
    '사업자 등록번호를 입력해주세요.',
    'Please enter your business registration number.',
    '事業者登録番号を入力してください。',
  ),
  REQUEST_BUSINESS_FILE_MSG: getStringByLang(
    '사업자 등록증 파일을 첨부해주세요.',
    'Please attach a business registration certificate file.',
    '事業者登録証ファイルを添付してください。',
  ),
  REQUEST_COMPANY_NAME_MSG: getStringByLang(
    '회사명을 입력해주세요.',
    'Please enter the company name.',
    '会社名を入力してください。',
  ),
  CONFIRM_CANCEL_MSG: getStringByLang(
    '정말 해지하시겠습니까?',
    'Are you sure you want to cancel?',
    '本当に解約しますか？',
  ),
  CANNOT_EDIT_MSG: getStringByLang(
    '이미 등록된 정보는 수정할 수 없습니다.',
    'Registered information cannot be modified.',
    'すでに登録された情報は修正できません。',
  ),
  NICKNAME_CAN_USE_MSG: getStringByLang(
    '사용 가능한 닉네임입니다.',
    'This nickname is available.',
    '使用可能なニックネームです。',
  ),
  NICKNAME_PLEASE_ENTER_MSG: getStringByLang(
    '닉네임을 입력해주세요.',
    'Please enter a nickname.',
    'ニックネームを入力してください。',
  ),
  NICKNAME_ALREADY_USE_MSG: getStringByLang(
    '이미 사용 중인 닉네임입니다.',
    'This nickname is already in use.',
    'すでに使用されているニックネームです。',
  ),
  NICKNAME_CHECK_DUPLICATE_MSG: getStringByLang(
    '닉네임 중복 확인을 해주세요.',
    'Please check for duplicate nicknames.',
    'ニックネームの重複確認をしてください。',
  ),
  CHANGE_USER_INFO_MSG: getStringByLang(
    '회원 정보가 변경되었습니다.',
    'User information has been changed.',
    '会員情報が変更されました。',
  ),
  PASSWORD_INVALID_MSG: getStringByLang(
    '비밀번호 형식이 올바르지 않습니다.',
    'Password format is invalid.',
    'パスワードの形式が正しくありません。',
  ),
  EMAIL_INVALID_MSG: getStringByLang(
    '이메일 형식이 올바르지 않습니다.',
    'Email format is invalid.',
    'メールの形式が正しくありません。',
  ),
  PHONE_INVALID_MSG: getStringByLang(
    '휴대폰 번호 형식이 올바르지 않습니다.',
    'Phone number format is invalid.',
    '携帯電話番号の形式が正しくありません。',
  ),
  REQUIRED_MSG: getStringByLang('필수 입력 항목입니다.', 'This is a required field.', '必須入力項目です。'),
  MAX_LENGTH_MSG: (max) =>
    getStringByLang(
      `최대 ${max}자 까지 입력 가능합니다.`,
      `You can enter up to ${max} characters.`,
      `最大${max}文字まで入力可能です。`,
    ),
  MIN_LENGTH_MSG: (min) =>
    getStringByLang(
      `최소 ${min}자 이상 입력 가능합니다.`,
      `You can enter at least ${min} characters.`,
      `最低${min}文字以上入力可能です。`,
    ),
  ONLY_NUMBER_MSG: getStringByLang('숫자만 입력 가능합니다.', 'Only numbers can be entered.', '数字のみ入力可能です。'),
  NO_SPACE_MSG: getStringByLang(
    '공백 없이 입력해주세요.',
    'Please enter without spaces.',
    'スペースなしで入力してください。',
  ),
  NO_SPECIAL_CHAR_MSG: getStringByLang(
    '특수문자 없이 입력해주세요.',
    'Please enter without special characters.',
    '特殊文字なしで入力してください。',
  ),
  INVALID_IMG_TYPE_MSG: getStringByLang(
    '이미지 파일 형식이 올바르지 않습니다.',
    'Image file format is invalid.',
    '画像ファイルの形式が正しくありません。',
  ),
  MAX_FILE_SIZE_MSG: (size) =>
    getStringByLang(
      `파일 용량은 ${size}MB 이하로 등록 가능합니다.`,
      `File size can be registered up to ${size}MB.`,
      `ファイル容量は${size}MB以下で登録可能です。`,
    ),
  INVALID_FILE_TYPE_MSG: getStringByLang(
    '파일 형식이 올바르지 않습니다.',
    'File format is invalid.',
    'ファイルの形式が正しくありません。',
  ),
  INVALID_URL_MSG: getStringByLang(
    'URL 형식이 올바르지 않습니다.',
    'URL format is invalid.',
    'URLの形式が正しくありません。',
  ),
  PASSWORD_MISMATCH_MSG: getStringByLang(
    '비밀번호가 일치하지 않습니다.',
    'Passwords do not match.',
    'パスワードが一致しません。',
  ),
};

export const CONFIG_TAGS = {
  TAG_POPULAR_LIST: getStringByLang(tag_popular_list_ko, tag_popular_list_en, tag_popular_list_jp),
  TAG_AZ_LIST: getStringByLang(tag_list_ko, tag_list_en, tag_list_jp),
  TAG_PERIODS_LIST: getStringByLang(tag_list_art_periods_ko, tag_list_art_periods_en, tag_list_art_periods_jp),
  TAG_COLOR_LIST: getStringByLang(tag_list_colours_ko, tag_list_colours_en, tag_list_colours_jp),
  TAG_PATTERN_TYPE_LIST: getStringByLang(
    tag_list_pattern_types_ko,
    tag_list_pattern_types_en,
    tag_list_pattern_types_jp,
  ),
  TAG_PATTERN_TECHNIQUE_LIST: getStringByLang(
    tag_list_pattern_techniques_ko,
    tag_list_pattern_techniques_en,
    tag_list_pattern_techniques_jp,
  ),
  TAG_FOOD_LIST: getStringByLang(tag_list_food_drink_ko, tag_list_food_drink_en, tag_list_food_drink_jp),
  TAG_OBJECTS_LIST: getStringByLang(tag_list_objects_ko, tag_list_objects_en, tag_list_objects_jp),
  TAG_SEASONS_LIST: getStringByLang(tag_list_seasons_ko, tag_list_seasons_en, tag_list_seasons_jp),
  TAG_FLOWERS_LIST: getStringByLang(tag_list_flowers_leaves_ko, tag_list_flowers_leaves_en, tag_list_flowers_leaves_jp),
  TAG_ANIMALS_BIRDS_LIST: getStringByLang(
    tag_list_animals_birds_ko,
    tag_list_animals_birds_en,
    tag_list_animals_birds_jp,
  ),
  TAG_TAGS_LIST: getStringByLang(tag_list_ko, tag_list_en, tag_list_jp),
  TAG_SELECT_SUB_CATEGORY: getStringByLang('인기', 'Popular', '人気'),
};

export const CONFIG_APP = {
  FRONT_URL: process.env.REACT_APP_FRONT_URL,
  API_URL: process.env.REACT_APP_API_URL,
  S3_URL: process.env.REACT_APP_S3_BUCKET_DOMAIN,
  UNITY_LOAD: process.env.REACT_APP_UNITY_LOAD,
  UNITY_DATA: process.env.REACT_APP_UNITY_DATA,
  UNITY_FRAMEWORK: process.env.REACT_APP_UNITY_FRAMEWORK,
  UNITY_CODE: process.env.REACT_APP_UNITY_CODE,
  MAX_FILE_SIZE: (size) => 1024 * 1024 * size,
  SUPPORTED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png'],
};
